type LandingSectionTone = 'soft' | 'solid' | 'white';

export const LANDING_SECTION_TITLE_CLASS_NAME = 'theme-heading-primary mb-4 text-4xl font-black leading-[1.05] tracking-[-0.04em] sm:mb-6 sm:text-5xl md:text-6xl';

export const PUBLIC_BULLET_HOVER_CLASS_NAME = 'transition-[transform,box-shadow] duration-300 ease-out motion-reduce:transform-none motion-reduce:transition-none lg:hover:-translate-y-1 lg:hover:scale-[1.01] lg:hover:drop-shadow-[0_12px_18px_rgb(var(--theme-shadow)/0.2)]';

interface LandingSectionClassNameOptions {
  className: string;
  fillAvailable?: boolean;
  tone?: LandingSectionTone;
}

export function landingSectionClassName({
  className,
  fillAvailable = true,
  tone = 'soft',
}: LandingSectionClassNameOptions) {
  return [
    'theme-public-section',
    'scroll-mt-24 sm:scroll-mt-28',
    fillAvailable ? 'flex min-h-[55svh] flex-col justify-center sm:min-h-[70svh]' : '',
    tone === 'solid'
      ? 'theme-public-section-solid'
      : tone === 'white'
        ? 'theme-public-section-white'
        : 'theme-public-section-soft',
    className,
  ].join(' ');
}
